/**
 * 동영상
 */
import { useState, useCallback, Fragment } from 'react';
import { useLoaderData } from 'react-router-dom';
import { Header } from "@features/content/Header";
import { apiSearchSlice } from "@features/api/apiSearchSlice";
import { setRequestToSearchParams } from '@utils/index';
import type { IContentData, ILoaderData, IVideo } from '@type/index';
import { ALIAS, CUR_NETWORK, NETWORK } from '@constants/index';
import { getLocalData } from '@features/api/apiLocalSlice';
import { NoData } from '../../components/contents/common/NoData';
import { useAppSelector } from '@hooks/defineRtkTypedHook';
import { selectL10N, setAlias } from '@features/ui/UiSlice';
import { VideoArticle } from '@components/contents/article/VideoArticle';
import { Paging } from '@components/contents/common/Paging';
import { Modal, IModal } from '@components/contents/common/Modal';

export const VideoLoader = (dispatch, option: IOption) =>
async ({ request, params }): Promise<IVideo | null> => {
    const searchParams = setRequestToSearchParams(request);

    // alias 변경 - searchParams 변경에 사용됨
    dispatch(setAlias(ALIAS.VIDEO));

    if(!searchParams?.keyword) {
        return null;
    }

    return CUR_NETWORK === NETWORK.OPDEV ? await getLocalData(ALIAS.VIDEO, searchParams) : await dispatch(apiSearchSlice?.endpoints?.getVideo?.initiate({ option, params: searchParams }));
};

interface IContentComponentProps {
    data: IContentData<IVideo>;
}
const ContentComponent = ({ data }: IContentComponentProps) => {
    const l10n = useAppSelector(selectL10N);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalData, setModalData] = useState<IModal['data']>({ url: null });

    const btnClickCallback = useCallback((url: string | null) => {
        setIsModalOpen(true);
        setModalData({ url });
    }, []);

    return <Fragment>
                <div className="search-content">
                    <ul className="column column-2">
                        {
                            data?.list.map((item, i) => <li key={i} className="search-item">
                                <VideoArticle item={item} l10n={l10n!} btnClickCallback={btnClickCallback}/>
                            </li>)
                        }
                    </ul>
                </div>
                <Paging endPage={data?.pagination?.endPage} showPage={5} l10n={l10n!} />
                <Modal type="video" isOpen={isModalOpen} setIsOpen={setIsModalOpen} data={modalData} />
            </Fragment>;
};

export const Video = () => {
    const { data, isLoading, isError } = useLoaderData() as ILoaderData<IContentData<IVideo>> || {};
    
    console.log('Video Data', data);

    if(isError || !Array.isArray(data?.list) || data?.list?.length === 0) {
        return <NoData />;
    }

    return <div className="search-result video">
        <Header totalCount={data?.pagination?.total} />
        <ContentComponent data={data} />
    </div>;
};